import { Checkbox } from "@/components/ui/checkbox";
import React, { ComponentProps } from "react";

type Props = {
  text?: React.ReactNode;
  label?: string;
  error?: string;
  "data-sentry-unmask"?: boolean;
} & ComponentProps<typeof Checkbox>;

export function CheckboxFormField({ ...props }: Props) {
  return (
    <div className="form-group">
      <div className="flex space-x-2 py-2">
        <Checkbox {...props} data-sentry-unmask={props["data-sentry-unmask"]} />
        <div className="grid gap-1.5 leading-none">
          <p className="text-muted-foreground mx-0 my-auto text-center">
            <label
              htmlFor={props.name}
              className="font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              {props.label}
            </label>
            {props.text}
          </p>
        </div>
      </div>
      <span className="form-error text-red-500">{props.error}</span>
    </div>
  );
}
